/* eslint-disable react/jsx-pascal-case */
import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import { Col, Container } from 'react-bootstrap'
import "../../styles/customers-styles.scss"
import { useFormik } from 'formik'
import FeatherIcon from 'feather-icons-react';
import { toast } from 'react-toastify';
import { setGlobalLoading } from 'redux/actions/actionCommon'

import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    ERROR_WHILE_UPDATING_CUSTOMER,
    CUSTOMER_UPDATED_SUCCESSFULLY
} from 'utlis/AppMessages/AppMessages'

import {
    editCustomer,
    cancelGetCustomerDetailsApi, getCustomerDetails, getCustomerAddresses, getCustomerCountries, getCustomerGroups
} from 'utlis/Apis/Customers_API'
import FormCustomersDetails from './Includes/FormCustomers__Details'
import { ERROR_WHILE_GETTING_CUSTOMER_DETAILS } from 'utlis/AppMessages/AppMessages'
import { initialCreateCustomerFormValues, validationSchema } from './FormHelper'
import CustomerAddresses from './CustomerAddresses/CustomerAddresses'

import CustomerPersonalInformation from './CustomerPersonalInformation/CustomerPersonalInformation'
import EditCustomerTopBar from './Includes/EditCustomerTopBar'
import FormPayment__Details from './Payment/FormPayment__Details'

function EditCustomer(props) {
    const submitButtonRef = useRef(null)
    const [step, setStep] = useState(1)
    const [customerId, setCustomerId] = useState("")
    const [addressess, setAddresses] = useState([])
    const [customer, setCustomer] = useState({})
    const [countries, setCountries] = useState([])
    const [createButtonLoading, setCreateButtonLoading] = useState(false)
    const [customerGroups, setCustomerGroups] = useState([])


    useEffect(() => {
        if (customerId) {
            getCustomerCountries().then(res => {
                const countriesData = res.data
                if (countriesData.success) {
                    setCountries(countriesData.data)
                }
                if (countriesData.error) {
                    console.log('Error occured while loading admin groups!', res)
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getCountries `, err.message)
                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            })
            getCustomerGroups(props.currentUser.userToken).then(res => {
                const customerGroupData = res.data
                if (customerGroupData.success) {
                    setCustomerGroups(customerGroupData.data)
                }
                if (customerGroupData.error) {
                    console.log('Error occured while loading customer groups!', res)
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getCustomerGroup `, err.message)
                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            })
        }
    }, [customerId, props.currentUser.userToken])

    useEffect(() => {
        if (customerId) {
            getCustomerAddresses_(customerId)

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId])

    const getCustomerAddresses_ = (user_id) => {
        if (!user_id) {
            return
        }
        getCustomerAddresses(props.currentUser.userToken, user_id).then(res => {
            const addressData = res.data
            if (addressData.success) {
                setAddresses(addressData.data)
            }
            if (addressData.error) {
                console.log('Error occured while loading admin groups!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getAddresses `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
    }

    useEffect(() => {
        const customerId = props.match.params.id ?? ""
        setCustomerId(customerId)
        getCustomerDetails(props.currentUser.userToken, customerId).then(res => {
            const customerData = res.data
            if (customerData.success) {
                setFormData(customerData.data)
            }
            if (customerData.error) {
                console.log(ERROR_WHILE_GETTING_CUSTOMER_DETAILS, res)
                toast.dismiss();
                toast.error(ERROR_WHILE_GETTING_CUSTOMER_DETAILS, {
                    autoClose: 3000,
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCustomerDetails `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })

        return () => {
            cancelGetCustomerDetailsApi()
        }
        // }
    }, [props.match.params.id, props.currentUser.userToken])

    const setFormData = (customerData) => {
        setCustomer(customerData)
    }

    const onCreateFormSubmit = values => {
        if (values && (step === 1 || step === 3)) {
            setGlobalLoading(true)
            setCreateButtonLoading(true)
            editCustomer(props.currentUser.userToken, values).then(res => {
                setGlobalLoading(false)
                setCreateButtonLoading(true)
                const addingCustomerGroup = res.data
                if (addingCustomerGroup.success) {
                    setCreateButtonLoading(false)
                    onSuccess(addingCustomerGroup.data)
                }
                if (addingCustomerGroup.error) {
                    onError(res)
                }
            }).catch(err => {
                setCreateButtonLoading(false)
                console.log(`${ERROR_WHILE__NAME} getEmailEvents `, err.message)
                onCatch()
            })
        }
    }
    const onError = (res) => {
        setCreateButtonLoading(false)
        console.log(ERROR_WHILE_UPDATING_CUSTOMER, res)
        toast.dismiss();
        toast.error(res.data.message || ERROR_WHILE_UPDATING_CUSTOMER, {
            autoClose: 3000,
        })
    }
    const onCatch = () => {
        toast.dismiss();
        toast.error(UNKNOWN_ERROR_OCCURED, {
            autoClose: 2500,
            onClose: () => {
                setCreateButtonLoading(false)
                setGlobalLoading(false)

            }
        })

    }
    const onSuccess = () => {
        window.scrollTo(0, 0)
        toast.dismiss();
        toast.success(CUSTOMER_UPDATED_SUCCESSFULLY, {
            autoClose: 2000,
            onClose: () => { }
        })
    }

    const formik = useFormik({
        initialValues: initialCreateCustomerFormValues(customer),
        validationSchema: validationSchema,
        onSubmit: onCreateFormSubmit,
        enableReinitialize: true,
    })

    const handleFormSubmission = (ev) => {
        ev.preventDefault()
        submitButtonRef.current.click()
    }
    const SideBarItem = ({ name, n }) => {
        return (<div className={`shrunk  ${step === n ? "border-bottom st-border-light" : "border-bottom st-border-light"}`} onClick={() => { setStep(n) }}>
            <div className={`customer-sidebar-item ${step === n ? "customer-active-sidebar-item" : ""}`} >
                <div className="top-sec d-flex align-items-center" >
                    {step === n ? <FeatherIcon
                        icon="disc"
                        size="8"
                        className="icon me-2" /> :
                        <FeatherIcon
                            icon="circle"
                            size="8"
                            className="icon me-2" />
                    }
                    <span>{name}</span>
                </div>
            </div>
        </div>)
    }

    const sideBarItems = ["Account Information", "Addresses", "Payment", "Customer View", "Credit Memo", "Newsletter", "Product Reviews", "Quote", "Wishlist"]
    return (
        <section id="app-customers__create-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-customers__create-details">
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize heading-sm">Edit Customer</p>
                        <p className="app-desc">
                            Customer have access to different parts of your store.
                            you can assign different customers different roles.
                        </p>
                    </div>
                    <div className="app-card customer">
                        <div className="app-card-content bg-white border st-default-rounded-block mb-3 pad-12-T pad-12-B ">
                            <div className="app-content-container categories-wrapper">
                                <EditCustomerTopBar
                                    loading={createButtonLoading}
                                    userId={customerId}
                                    handleFormSubmission={handleFormSubmission}
                                    setStep={(s) => { setStep(s) }}
                                    step={step}
                                    handleDelete={() => {
                                        props.history.push('/my-sales/customers/', {
                                            shouldReload: true
                                        })
                                    }} />

                                <div className="categories-wrapper-inner d-flex flex-wrap customer">
                                    <div className="customer-sidebar">
                                        <div className="inner">
                                            {sideBarItems.map((e, index) => <SideBarItem name={e} n={index + 1} key={index} />)}
                                        </div>
                                    </div>
                                    <div className="category-data-view media-body position-relative bg-white  pad-20-L pad-20-R">
                                        {step === 1 ?
                                            <Col xs={12} md={12} lg={9} className="px-0">
                                                <div className="app-header-wrapper heading-sm pad-15">
                                                    <p className="app-heading text-uppercase st-text-light st-text-light st-fs-16 st-fw-700">Account Information</p>
                                                </div>
                                                <div className="pad-12-L pad-12-R pad-12-B">
                                                    <div className="app-card customer-form">
                                                        <div className="app-card-content border st-default-rounded-block mb-3 pad-12-T pad-12-B pad-12-R pad-12-L">
                                                            <div className="app-card mb-3 mb-lg-4">
                                                                <div className="app-card-content  pad-20-LR pad-20-T">
                                                                    <Col xs={12} md={9} lg={11} className="px-0">
                                                                        <form
                                                                            onSubmit={formik.handleSubmit}
                                                                            noValidate
                                                                            autoComplete="off">
                                                                            <FormCustomersDetails
                                                                                formik={formik}
                                                                                adminGroups={[]}//{adminGroups}
                                                                                customerGroups={customerGroups}
                                                                            />
                                                                            <button type="submit" ref={submitButtonRef} className="d-none">submit</button>
                                                                        </form>
                                                                    </Col>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col> : ""
                                        }
                                        {step === 2 &&
                                            <div className="pad-20-R">
                                                <CustomerAddresses
                                                    getCustomerAddresses_={() => {
                                                        getCustomerAddresses_(customerId)
                                                    }}
                                                    countries={countries}
                                                    addressess={addressess}
                                                    id={customerId}
                                                    customer={customer}
                                                />
                                            </div>
                                        }
                                        {step === 3 &&
                                            <Col xs={12} md={12} lg={9} className="px-0">
                                                <div className="app-header-wrapper heading-sm pad-15">
                                                    <p className="app-heading text-uppercase st-text-light st-text-light st-fs-16 st-fw-700">Payment</p>
                                                </div>
                                                <div className="pad-12-L pad-12-R pad-12-B">
                                                    <div className="app-card customer-form">
                                                        <div className="app-card-content border st-default-rounded-block mb-3 pad-12-T pad-12-B pad-12-R pad-12-L">
                                                            <div className="app-card mb-3 mb-lg-4">
                                                                <div className="app-card-content  pad-20-LR pad-20-T">
                                                                    <Col xs={12} md={9} lg={11} className="px-0">
                                                                        <form
                                                                            onSubmit={formik.handleSubmit}
                                                                            noValidate
                                                                            autoComplete="off">
                                                                            <FormPayment__Details
                                                                                formik={formik}
                                                                            />
                                                                            <button type="submit" ref={submitButtonRef} className="d-none">submit</button>
                                                                        </form>
                                                                    </Col>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        }
                                        {step === 4 &&
                                            <div className="pad-20-R">
                                                <div className="app-header-wrapper heading-sm pad-15">
                                                    <p className="app-heading text-uppercase st-text-light st-fs-16 st-fw-700">Personal Information</p>
                                                </div>
                                                <div className="pad-12-L  pad-20-R">
                                                    <CustomerPersonalInformation
                                                        customer={customer}
                                                        addressess={addressess}
                                                        countries={countries}
                                                        id={customerId}
                                                        refreshAddress={() => {
                                                            getCustomerAddresses_(customerId)
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        }
                                        {(step !== 1 && step !== 2 && step !== 3 && step !== 4) ? <Col xs={12} md={12} lg={12} className="px-0">
                                            <div className="app-card mb-3 mb-lg-4">
                                                {/* card heading */}
                                                <div className="app-header-wrapper heading-sm bg-white pad-15 border-bottom st-border-light">
                                                    {/* heading */}
                                                    <p className="app-heading text-capitalize">Address</p>
                                                </div>
                                                <div className="app-card-content bg-white  pad-20-LR pad-20-T">
                                                    <Col xs={12} md={12} lg={12} className="px-0">
                                                        Yet to implement
                                                    </Col>
                                                </div>
                                            </div>
                                        </Col> : ""
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </section >
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(EditCustomer)